import { ErrorResponse } from '@/api/types';
import { format } from 'date-fns';
import { AxiosError } from 'axios';

const CLOSED_PERIOD_ERROR_PREFIX = 'Cannot create or modify entries with dates on or before';
const CLOSED_PERIOD_DATE_REGEX = /on or before (\d{4}-\d{2}-\d{2})/;

const parseLocalDate = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

const getClosedPeriodConstraintMessage = (error: AxiosError<ErrorResponse>) => {
  return (
    error.response?.data.errors?.find((message) => message.includes(CLOSED_PERIOD_ERROR_PREFIX)) ||
    null
  );
};

const getClosedPeriodDateFromError = (error: AxiosError<ErrorResponse>) => {
  const constraintMessage = getClosedPeriodConstraintMessage(error);
  const closedDate = constraintMessage?.match(CLOSED_PERIOD_DATE_REGEX)?.[1];

  return closedDate ? parseLocalDate(closedDate) : null;
};

const isClosedPeriodError = (error: AxiosError<ErrorResponse>) => {
  return Boolean(getClosedPeriodConstraintMessage(error));
};

const getClosedPeriodErrorMessage = (
  error: AxiosError<ErrorResponse>,
  fallbackDate?: Date | null,
) => {
  const closedDate = getClosedPeriodDateFromError(error) || fallbackDate;

  if (!closedDate) {
    return '⚠️ No puede seleccionar una fecha contable igual o anterior al cierre del período.';
  }

  return `⚠️ Período cerrado hasta el ${format(closedDate, 'dd/MM/yyyy')}. No puede seleccionar una fecha contable igual o anterior.`;
};

export { getClosedPeriodErrorMessage, getClosedPeriodDateFromError, isClosedPeriodError };
